
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/podcasts/sorting/visited/[pageNumber]",
      function () {
        return require("private-next-pages/podcasts/sorting/visited/[pageNumber]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/podcasts/sorting/visited/[pageNumber]"])
      });
    }
  